module.exports = __webpack_public_path__ + "img/Inflammation-OVCA_GSE227019.879b5813.png";